import { render, staticRenderFns } from "./ProgramReferencesTab.vue?vue&type=template&id=f9751d9a"
import script from "./ProgramReferencesTab.vue?vue&type=script&lang=js"
export * from "./ProgramReferencesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports